/* src/app/forms/produtos/meli/meli-new-wizard/item-meli-catalogo-card/item-meli-catalogo-card.component.scss */
.catalog-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid var(--tem-border, #e5e8ec);
  border-radius: var(--tem-radius, 10px);
  background: var(--tem-surface, #fff);
  padding: 12px 16px;
}
.catalog-card-title {
  font-size: var(--tem-fs-lg, 16px);
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.catalog-card-subtitle {
  font-size: var(--tem-fs-sm, 12px);
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
}
.product-item-content {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
}
.product-item-image {
  width: 50%;
  text-align: -webkit-center;
}
.product-item-detail {
  width: 50%;
}
.product-item {
  display: flex;
  flex-direction: column;
  padding-bottom: 4px;
}
.product-item-detail-container {
  border-radius: var(--tem-radius, 10px);
  max-height: 150px;
  overflow: auto;
  padding: 10px;
  border: 1px solid var(--tem-border, #e5e8ec);
  background: var(--tem-surface-2, #f7f8fa);
}
.attrib-data {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid var(--tem-border, #ededed);
}
.attrib-data:last-child {
  border-bottom: none;
}
.attrib-data .label {
  font-weight: 500;
  width: 50%;
  padding: 8px 12px;
  align-self: center;
  font-size: var(--tem-fs-sm, 12px);
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
}
.attrib-data .value {
  width: 50%;
  padding: 8px 12px;
  align-self: center;
  font-size: var(--tem-fs-sm, 12px);
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
}
.card-action {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
  border-top: 1px solid var(--tem-border, #e5e8ec);
  padding-top: 10px;
}
/*# sourceMappingURL=item-meli-catalogo-card.component.css.map */
